import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LookupValuesService {
    baseUrl: string;
    constructor(private http: HttpClient) { }

    private handleError<T>(operation = 'operation', result?: T) {

        return (error: any): Observable<T> => {
            console.log("Error occurred in ", operation);
            console.log(error);
            return of(result as T);
        }

    }

    public GetNewsMessageTypeOptions(): Observable<any> {

        this.baseUrl = environment.apiBase.concat("LookupValues/GetNewsMessageTypeOptions");

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(this.handleError<any[]>('GetNewsMessageTypeOptions', [])));
    }

    public GetMessageSourceTypeNoNewsOptions(): Observable<any> {

        this.baseUrl = environment.apiBase.concat("LookupValues/GetMessageSourceTypeNoNewsOptions");

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(this.handleError<any[]>('GetMessageSourceTypeNoNewsOptions', [])));
    }


    public GetPropertyTypeOptions(): Observable<any> {

        this.baseUrl = environment.apiBase.concat("LookupValues/GetPropertyTypeOptions");

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(this.handleError<any[]>('GetPropertyTypeOptions', [])));
    }

    public GetDealTypeOptions(): Observable<any> {

        this.baseUrl = environment.apiBase.concat("LookupValues/GetDealTypeOptions");

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(this.handleError<any[]>('GetDealTypeOptions', [])));
    }

    public GetRegionOptions(): Observable<any> {

        this.baseUrl = environment.apiBase.concat("LookupValues/GetRegionOptions");

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(this.handleError<any[]>('GetRegionOptions', [])));
    }

    public GetRegionOptionsByCountry(countryId): Observable<any> {

        this.baseUrl = environment.apiBase.concat("LookupValues/GetRegionOptionsByCountry?CountryID=" + countryId);

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(this.handleError<any[]>('GetRegionOptionsByCountry', [])));
    }

    public GetCountryOptions(): Observable<any> {

        this.baseUrl = environment.apiBase.concat("LookupValues/GetCountryOptions");

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(this.handleError<any[]>('GetCountryOptions', [])));
    }

    public GetStateOptions(countryId): Observable<any> {

        this.baseUrl = environment.apiBase.concat("LookupValues/GetStateOptions?CountryID=" + countryId);

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(this.handleError<any[]>('GetStateOptions', [])));
    }
    public GetStateOptionsByRegion(regionId): Observable<any> {

        this.baseUrl = environment.apiBase.concat("LookupValues/GetStateOptionsByRegion?RegionId=" + regionId);

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(this.handleError<any[]>('GetStateOptionsByRegion', [])));
    }

    public GetMemberOptions(): Observable<any> {

        this.baseUrl = environment.apiBase.concat("LookupValues/GetMemberOptions");

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(this.handleError<any[]>('GetMemberOptions', [])));
    }

    public GetMemberTypeOptions(): Observable<any> {

        this.baseUrl = environment.apiBase.concat("LookupValues/GetMemberTypeOptions");

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(this.handleError<any[]>('GetMemberTypeOptions', [])));
    }

    public GetMemberOfficeTypeOptions(): Observable<any> {

        this.baseUrl = environment.apiBase.concat("LookupValues/GetMemberOfficeTypeOptions");

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(this.handleError<any[]>('GetMemberOfficeTypeOptions', [])));
    }

    public GetNAIRoleOptions(): Observable<any> {

        this.baseUrl = environment.apiBase.concat("LookupValues/GetNAIRoleOptions");

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(this.handleError<any[]>('GetNAIRoleOptions', [])));
    }

    public GetAppRoleOptions(): Observable<any> {

        this.baseUrl = environment.apiBase.concat("LookupValues/GetAppRoleOptions");

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(this.handleError<any[]>('GetAppRoleOptions', [])));
    }
    public GetSpecialtyOptions(): Observable<any> {

        this.baseUrl = environment.apiBase.concat("LookupValues/GetSpecialtyOptions");

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(this.handleError<any[]>('GetSpecialtyOptions', [])));
    }      
    public GetUnitOfMeasurementTypeOptions(): Observable<any> {

        this.baseUrl = environment.apiBase.concat("LookupValues/GetUnitOfMeasurementTypeOptions");

        return this.http.get<any[]>(this.baseUrl).pipe(catchError(this.handleError<any[]>('GetUnitOfMeasurementTypeOptions', [])));
    }
}
